export function productSelect() {
    let factionFilter = $('.faction-select-filter');
    let factionSelectProducts = $('.faction-select-products');
    let factionSelectGroups = $('.faction-select-product-group');


    if (factionFilter.length && factionSelectProducts.length && factionSelectGroups.length) {
        factionFilter.change(function () {
            let factionId = factionFilter.val();
            let selectedProductsArray = [];
            $('.faction-selected-products option').each(function() {
                selectedProductsArray.push($(this).val());
            });

            factionSelectGroups.empty();
            factionSelectProducts.empty();

            if (factionId > 0) {
                _updateFactionView(factionId, factionSelectProducts, factionSelectGroups, null, selectedProductsArray);
            }
        });

        factionSelectGroups.change(function() {
            let selectedProductsArray = [];
            $('.faction-selected-products option').each(function() {
                selectedProductsArray.push($(this).val());
            });
            let groupId = factionSelectGroups.val();
            let factionId = factionFilter.val();
            factionSelectProducts.empty();

            _updateFactionView(factionId, factionSelectProducts, factionSelectGroups, groupId, selectedProductsArray);
        });


        factionSelectProducts.change(function () {
            let options = $(this).find('option:selected');

            options.each(function() {
               let option = $(this);

                option.prop('selected', false).remove().appendTo($('.faction-selected-products'));

                $('.faction-select-hidden-products').find('option[value="'+option.val()+'"]').prop('selected', true);
            });

        });

        $('.faction-selected-products').change(function () {
            let options = $(this).find('option:selected');

            options.each(function() {
                let option = $(this);

                let productGroup = option.data('group-id');
                if(parseInt(factionSelectGroups.val()) == parseInt(productGroup)) {
                    option.prop('selected',false).appendTo(factionSelectProducts);
                } else {
                    option.remove();
                }
                $('.faction-select-hidden-products').find('option[value="'+option.val()+'"]').prop('selected', false);

            });
        });
    }
}

function _updateFactionView(faction, factionProducts, factionGroups, productGroupId = null, selectedProducts = []) {
    $.ajax({
        url: '/ajax/factionSelect',
        type: 'post',
        data: {
            "faction": faction,
            "productGroup": productGroupId,
            "selectedProducts": selectedProducts
        },
        success: function (data) {

            $.each(data.groups, function (key, value) {
                factionGroups.append('<option value="' + key + '">' + data.groups[key] + '</option>')
            });

            $.each(data.products, function (key, value) {
                factionProducts.append('<option data-group-id="'+productGroupId+'" value="' + key + '">' + data.products[key] + '</option>')
            });
        }
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/contentElements/productSelect.js